import { customFieldsFilterAtom } from 'atoms/filters/sim';
import { customFieldsHintsAtom } from 'src/atoms/hints/sim';
import { CustomFieldInputs } from 'src/common/components/Filters/Inputs/customFields/CustomFieldsInputs';

export const SimProfilesCustomFieldInputs = () => {
  return (
    <CustomFieldInputs
      customFieldsFilterAtom={customFieldsFilterAtom}
      customFieldsHintsAtom={customFieldsHintsAtom}
    />
  );
};
